// extracted by mini-css-extract-plugin
export default {"srOnly":"rn3jUZ","postCount":"PmSYjD"};